




const Plugin = {};
Plugin.install = (Vue, options) => {
  /*
 * 格式化日期 create by guoxingwang 2017-07-15
 * type 01 '-' 02 '/' 03  '.'
 * format  01 年月日  02 年月日 时分 03 年月日时分秒
 * */
  Vue.prototype.$formatDate = (date, type, format) => {
    if (!date) {
      return ""
    } else {
      let nowDate = new Date(date);
      let y = nowDate.getFullYear();
      let m = nowDate.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = nowDate.getDate();
      d = d < 10 ? "0" + d : d;
      let h = nowDate.getHours();
      h = h < 10 ? "0" + h : h;
      let min = nowDate.getMinutes();
      min = min < 10 ? "0" + min : min;
      let s = nowDate.getSeconds();
      s = s < 10 ? "0" + s : s;
      let separatorType = "";
      switch (type) {
        case '01':
          separatorType = '-';
          break;
        case '02':
          separatorType = '/';
          break;
        case '03':
          separatorType = '.';
          break;
        default:
          separatorType = '-';
          break;
      }
      if (format == '01') { //年月日
        return y + separatorType + m + separatorType + d;
      } else if (format == '02') { //年月日 时分
        return y + separatorType + m + separatorType + d + " " + h + ":" + min;
      } else if (format == '03') { //年月日  时分秒
        return y + separatorType + m + separatorType + d + " " + h + ":" + min + ":" + s;
      } else {
        alert('时间格式输入有误')
      }
    }
  }

  /**
 * 提示信息
 * type类型  info提示  success成功 warning警告 error错误 loading加载
 * */
  Vue.prototype.$tips = (target, s, type) => {
    target.$Message[type]({
      content: s,
      duration: 3,
      closable: true,
      onClose: () => {
        target.$Message.destroy();
      }
    });
  };
  /**
   * 比较两个时间大小
   * 第一个参数大返回true，否则返回false
   * */
  Vue.prototype.$compareDate = (date1, date2) => {
    let oDate1 = new Date(date1);
    let oDate2 = new Date(date2);
    if (oDate1.getTime() >= oDate2.getTime()) {
      return true;
    } else {
      return false;
    }
  };

/**
 * 返回表格的最大显示区域
 * 64 页面头部高度---yn-header
 * 32 tags标签高度
 * 10 右侧区域的上内边距
 * 15 .table的上外边距
 * 58 搜索框的高度
 * 35 底部分页器的高度
 * n 搜索框占几行  默认为1行
 */
Vue.prototype.$getBrowerHeight = (n = 1) => {
  let height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  let max_height = parseInt(height) - 64 - 32 - 10 - 15 - 35 - 58 * n;
  return max_height;
}
}

export default Plugin;




// WEBPACK FOOTER //
// ./src/tools/index.js